import { jsx as _jsx } from "react/jsx-runtime";
var StarCircle = function StarCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM14.8637 16.8135C14.9398 16.8531 15.0226 16.8724 15.1049 16.8724C15.2132 16.8724 15.321 16.8391 15.4117 16.7724C15.5716 16.6557 15.6518 16.4583 15.6179 16.263L15.1122 13.3318L17.258 11.2563C17.4007 11.1182 17.4523 10.9109 17.3913 10.7214C17.3304 10.5328 17.1674 10.3948 16.9705 10.3667L14.0018 9.93542L12.6747 7.26562C12.4986 6.91146 11.9179 6.91146 11.7419 7.26562L10.4148 9.93542L7.44603 10.3667C7.24916 10.3948 7.08613 10.5328 7.0252 10.7214C6.96426 10.9109 7.01582 11.1182 7.15853 11.2563L9.30436 13.3318L8.79864 16.263C8.76478 16.4583 8.84447 16.6557 9.00488 16.7724C9.16426 16.8891 9.37676 16.9047 9.5528 16.8135L12.208 15.426L14.8637 16.8135Z",
      fill: color
    })
  });
};
export default StarCircle;